var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
const SvgArtifact = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 960 960",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m667.3 97.9-82.4-82.4V.5c45 0 134.9 7.5 142.4 22.4v75ZM292.7 97.9l82.4-82.4V.5c-45 0-134.9 7.5-142.4 22.4v75ZM577.4 120.4l-97.4-90-97.4 90zM97.9 292.7l-82.4 82.4H.5c0-45 7.5-134.9 22.4-142.4h75ZM97.9 667.3l-82.4-82.4H.5c0 45 7.5 134.9 22.4 142.4h75ZM120.4 382.6l-90 97.4 90 97.4zM292.7 862.1l82.4 82.4v15c-45 0-134.9-7.5-142.4-22.4v-75ZM667.3 862.1l-82.4 82.4v15c45 0 134.9-7.5 142.4-22.4v-75ZM382.6 839.6l97.4 90 97.4-90zM862.1 667.3l82.4-82.4h15c0 45-7.5 134.9-22.4 142.4h-75ZM862.1 292.7l82.4 82.4h15c0-45-7.5-134.9-22.4-142.4h-75ZM839.6 577.4l90-97.4-90-97.4z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 480,
  cy: 480,
  r: 300
})));
const Memo = /*#__PURE__*/memo(SvgArtifact);
export default Memo;